import React from "react";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import "../../../styles/payrole-system/payrole-table.css";

const mockGeneratedFiles = [
  {
    id: 1,
    fileName: "HDFC_NEFT_June2025.txt",
    format: "NEFT",
    bank: "HDFC",
    employees: 4,
    amount: "₹103,000",
    created: "25/06/2025",
    status: "Uploaded",
  },
  {
    id: 2,
    fileName: "ICICI_Payroll_June2025.csv",
    format: "CSV",
    bank: "ICICI",
    employees: 4,
    amount: "₹103,000",
    created: "24/06/2025",
    status: "Generated",
  },
];

const GeneratedBankFilesTable = () => {
  const handleDownload = (fileId) => {};

  const handleUpload = (fileId) => {};

  const columns = [
    {
      dataField: "fileName",
      text: "File Name",
      formatter: (_, row) => (
        <div className="pp-bank-file-info">
          <svg
            className="pp-bank-file-icon"
            width="16"
            height="16"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14,2 14,8 20,8" />
            <line x1="16" y1="13" x2="8" y2="13" />
            <line x1="16" y1="17" x2="8" y2="17" />
            <polyline points="10,9 9,9 8,9" />
          </svg>
          <span className="pp-bank-file-name">{row.fileName}</span>
        </div>
      ),
    },
    {
      dataField: "format",
      text: "Format",
      formatter: (_, row) => (
        <span className="pp-bank-status-pill pp-bank-format-pill">
          {row.format}
        </span>
      ),
    },
    {
      dataField: "bank",
      text: "Bank",
      formatter: (_, row) => <span className="tb-data">{row.bank}</span>,
    },
    {
      dataField: "employees",
      text: "Employees",
      formatter: (_, row) => <span className="tb-data">{row.employees}</span>,
    },
    {
      dataField: "amount",
      text: "Amount",
      formatter: (_, row) => (
        <span className="pp-bank-amount tb-data">{row.amount}</span>
      ),
    },
    {
      dataField: "created",
      text: "Created",
      formatter: (_, row) => <span className="tb-data">{row.created}</span>,
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (_, row) => (
        <span
          className={`pp-bank-status-pill ${
            row.status === "Generated"
              ? "pp-bank-status-generated"
              : "pp-bank-status-uploaded"
          }`}
        >
          {row.status}
        </span>
      ),
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: (_, row) => (
        <div className="pp-bank-actions">
          <button
            className="pp-bank-action-btn pp-bank-download-btn"
            onClick={() => handleDownload(row.id)}
            aria-label={`Download ${row.fileName}`}
          >
            <svg
              className="pp-bank-action-icon"
              width="16"
              height="16"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="7,10 12,15 17,10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
            Download
          </button>
          {row.status === "Generated" && (
            <button
              className="pp-bank-action-btn pp-bank-upload-btn"
              onClick={() => handleUpload(row.id)}
              aria-label={`Upload ${row.fileName}`}
            >
              <svg
                className="pp-bank-action-icon"
                width="16"
                height="16"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="17,8 12,3 7,8" />
                <line x1="12" y1="3" x2="12" y2="15" />
              </svg>
              Upload
            </button>
          )}
        </div>
      ),
    },
  ];

  return (
    <div className="pp-employee-payroll-table-container">
      <div className="pp-employee-payroll-card-header">
        Generated Bank Files
      </div>

      <div className="pp-employee-payroll-table-wrapper">
        <PaymentLinkTable
          tableData={mockGeneratedFiles}
          tableColumns={columns}
          wrapperClass="pp-employee-payroll-table"
          headerWrapperClass="pp-employee-payroll-table-head"
          rowWrapperClass="pp-employee-payroll-table-row"
        />
      </div>
    </div>
  );
};

export default GeneratedBankFilesTable;
